<div class="io-mode-and-power">
	<slot />
</div>

<style>
	.io-mode-and-power {
		display: grid;
		gap: var(--spacing-s);
		grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
		align-items: start;
	}
</style>
